import React from 'react';
import Chip from '@/components/chip/chip.component';
import './filters.styles.scss';

interface Props {
  filters: string[];
  onChange: (value: string) => void;
  activeFilter: string;
}

const Filters: React.FC<Props> = ({ filters, onChange, activeFilter }) => {
  return (
    <div className="filters">
      {filters.map((filter) => (
        <Chip
          key={filter}
          isActive={activeFilter === filter}
          onClick={() => onChange(filter)}
          label={filter}
        />
      ))}
    </div>
  );
};

export default Filters;
